import React, {Component, Fragment} from 'react';
import {Card, CardBody, Row} from 'reactstrap';
import {Colxx, Separator} from '../../../components/common/CustomBootstrap';
import Breadcrumb from "../../../containers/navs/Breadcrumb";
import AlertsList from "../../../containers/AlertsList";

class Alerts extends Component {
  render() {
    const {match, history} = this.props;
    return (
      <Fragment>
        <Row>
          <Colxx xxs="12">
            <Breadcrumb match={match}/>
            <Separator className="mb-5"/>
          </Colxx>
        </Row>
        <Row>
          <Colxx xxs="12" className="mb-4">
            <Card className="h-100">
              <CardBody>
                <AlertsList history={history}/>
              </CardBody>
            </Card>
          </Colxx>
        </Row>
      </Fragment>
    );
  }
}

export default Alerts;
